import {
  createContract,
  createContractTemplate,
  deleteContractTemplate,
  downloadContractPdf,
  getContractHistory,
  getContracts,
  getContractTemplateFields,
  getContractTemplates,
  getContractTemplatesFile,
  getOneContract,
  getOneContractTemplate,
  getOneContractTemplateFile,
  updateContract,
  updateContractTemplate,
  updateOneContract,
} from '@/api/contracts'

export default {
  FETCH_CONTRACTS({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      getContracts(params).then(response => {
        commit('SET_CONTRACTS', response.data)
        commit('SET_CONTRACTS_V2', response.data)
        resolve(response.data)
      }).catch(error => {
        // console.log(error.response)
        reject(error.response)
      })
    })
  },
  ADD_CONTRACT(_, data) {
    return createContract(data)
  },
  EDIT_CONTRACT(_, data) {
    return updateContract(data)
  },
  FETCH_ONE_CONTRACT({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      getOneContract(data).then(response => {
        commit('SET_ONE_CONTRACT', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error.response)
      })
    })
  },
  UPDATE_ONE_CONTRACT(_, data) {
    return new Promise((resolve, reject) => {
      updateOneContract(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error.response)
      })
    })
  },
  DOWNLOAD_CONTRACT_PDF(_, data) {
    return downloadContractPdf(data)
  },
  FETCH_CONTRACT_HISTORY({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      getContractHistory(data).then(response => {
        commit('SET_CONTRACT_HISTORY', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error.response)
      })
    })
  },
  FETCH_CONTRACT_TEMPLATES({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      getContractTemplates(data).then(response => {
        commit('SET_CONTRACT_TEMPLATES', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error.response)
      })
    })
  },

  FETCH_CONTRACT_TEMPLATES_FILE({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      getContractTemplatesFile(data).then(response => {
        commit('SET_CONTRACT_TEMPLATES_FILE', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error.response)
      })
    })
  },

  FETCH_ONE_CONTRACT_TEMPLATE_FILE({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      getOneContractTemplateFile(data).then(response => {
        commit('SET_ONE_CONTRACT_TEMPLATE_FILE', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error.response)
      })
    })
  },
  EDIT_CONTRACT_TEMPLATE(_, data) {
    return updateContractTemplate(data)
  },
  ADD_CONTRACT_TEMPLATE(_, data) {
    return createContractTemplate(data)
  },
  DELETE_CONTRACT_TEMPLATE(_, data) {
    return deleteContractTemplate(data)
  },
  FETCH_CONTRACT_TEMPLATE_FIELDS({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      getContractTemplateFields(data).then(response => {
        commit('SET_CONTRACT_TEMPLATE_FIELDS', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error.response)
      })
    })
  },
}